import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";

const TermsPage = () => (
  <LegalDocumentPage id="terms" labelKey="Terms & Conditions" contentKey="terms" path="/terms" />
);

export default TermsPage;
